import React, { Component } from "react"
import {
  Alert,
  Button,
  ButtonToolbar,
  Col,
  ControlLabel,
  Form,
  Image,
  FormControl,
  ToggleButtonGroup,
  ToggleButton,
  FormGroup,
} from "react-bootstrap"
import { browserHistory } from "react-router"

import { initField } from "../../lib/form-builder"
import FieldGroup from "../FieldGroup"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { email, nonEmpty } from "../../lib/validators"
import { blockingFetchService } from "../../lib/blockingFetch"
import FontAwesome from "react-fontawesome"
import { DEFAULT_NB_DAYS_EXTENSION, LoanCollateral, validateTextState } from "../../lib/utils"
import ProcessesStatus from "../fragments/ProcessesStatus"
import moment from "moment"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

class OrganizationForm extends Component {

  constructor(props) {

    super(props)
    const { organization } = this.props
    const isNew = !organization
    this.todayDate = moment().format('YYYY-MM-DD')

    this.state = {
      isNew: isNew,
      file: null,
      running: false,
      success: false,
      error: null,
      progressNumber: 0,
      resubmitId: null,
      loanCollaterals: !isNew ? organization.loanCollaterals : [],
      canLinkToExistingDevice: !isNew ? organization.canLinkToExistingDevice : true,
      iconeURL: (!isNew && organization.iconId) ? apiServerApi.organizationIconURL(organization.id) : null,

      ...initField(this, 'name', isNew ? '' : organization.name, nonEmpty),
      ...initField(this, 'email', isNew ? '' : organization.email, email),
      ...initField(this, 'deviceApiKey', isNew ? '' : organization.deviceApiKey, nonEmpty),
      ...initField(this, 'active', (!isNew && organization.active === false) ? 'false' : 'true', nonEmpty),

      loanCollateralsValidate: (!isNew && organization.loanCollaterals.length) ? 'success' : null,
      openedOn: !isNew ? moment(organization.openedOn).format("YYYY-MM-DD") : this.todayDate,
      openedOnValidationState: 'success',
      showOpenedOnHelp: false,

      nbDaysManualExtension: isNew ? DEFAULT_NB_DAYS_EXTENSION : organization.nbDaysManualExtension,
      manualExtensionState: 'success',
    }
  }

  componentDidMount() {
    if(!this.state.isNew) {
      this.validateAllValues()
    }
  }

  validateAllValues = () => {
    const { active, name, email, deviceApiKey } = this.state
    name.validationCurrentValue()
    email.validationCurrentValue()
    deviceApiKey.validationCurrentValue()
    active.validationCurrentValue()
  }

  handleImageChange = e => {

    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onloadend = () => {
      this.setState({
        file,
        iconeURL: reader.result
      })
    }
    reader.readAsDataURL(file)
  }

  validateManualExtension = nb => (nb !== '' && !isNaN(nb) && nb >= 0) ? 'success' : 'error'

  openedOnChanged = openedOn => this.setState({
    openedOn,
    openedOnValidationState: validateTextState(openedOn, false),
  })

  manualExtensionChanged = nb => this.setState({
    nbDaysManualExtension: nb,
    manualExtensionState: this.validateManualExtension(nb),
  })

  valid = () => {
    const { openedOnValidationState, active, name, email, deviceApiKey, loanCollaterals,
      manualExtensionState } = this.state
    return !!(
      openedOnValidationState === 'success' &&

      manualExtensionState === 'success' &&

      name.validation &&
      name.validation.valid &&

      email.validation &&
      email.validation.valid &&

      deviceApiKey.validation &&
      deviceApiKey.validation.valid &&

      active.value &&

      loanCollaterals.length > 0
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveOrganization()
    }
    else {
      const { loanCollaterals, openedOn, nbDaysManualExtension: nbDays } = this.state
      this.validateAllValues()
      this.setState({
        error: 'Some fields are incorrect.',
        loanCollateralsValidate: this.getLoanCollateralsValidateState(loanCollaterals),
        openedOnValidationState: validateTextState(openedOn, false),
        manualExtensionState: this.validateManualExtension(nbDays),
      })
    }
  }

  saveOrganization = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
      progressNumber: 0,
    })

    const { canLinkToExistingDevice, openedOn, active, name, email,
      deviceApiKey, loanCollaterals, isNew, nbDaysManualExtension } = this.state,

    data = {
      active: active.value,
      openedOn: moment(openedOn).format("YYYY-MM-DDTHH:mm:ss"),
      name: name.value,
      email: email.value,
      deviceApiKey: deviceApiKey.value,
      loanCollaterals,
      canLinkToExistingDevice,
      nbDaysManualExtension
    },

    { organization } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.saveOrganization(accessToken, data)
        : apiServerApi.updateOrganization(accessToken, organization.id, data),
      response => this.saveOrganizationSuccess(response),
      error => this.saveOrganizationFailure(error),
      _ => {}
    )
  }

  saveOrganizationSuccess = organization => {

    // If there is a file to upload
    const { file } = this.state
    if(file) {
      this.saveIcon(organization.id, file)
    }
    else {
      this.saveIconSuccess()
    }
  }

  saveOrganizationFailure = error => this.setState({
    running: false,
    success: false,
    error: error.text,
  })

  saveIcon = (organizationId, file) => {

    this.setState({
      running: true,
      success: false,
      error: null,
      resubmitId: null,
      progressNumber: 1,
    })

    blockingFetchService(
      accessToken => apiServerApi.saveOrganizationIcon(accessToken, organizationId, file),
      _ => this.saveIconSuccess(),
      error => this.saveIconFailure(organizationId, error),
      _ => {}
    )
  }

  saveIconSuccess = () => {

    this.setState({
      running: false,
      success: true,
      error: null,
      resubmitId: null,
      progressNumber: 2,
    })

    setTimeout(() => browserHistory.push('/organizations'), 1000)
  }

  saveIconFailure = (organizationId, error) => this.setState({
    running: false,
    success: false,
    error: error.text,
    resubmitId: organizationId,
  })

  /**
   * Resubmit a failed task
   */
  resubmitSubTask = () => {
    const { progressNumber, resubmitId, file } = this.state
    switch(progressNumber) {
      case 1:
        this.saveIcon(resubmitId, file)
      break
      default: break
    }
  }

  getLoanCollateralsValidateState = matches => {
    const length = matches ? matches.length : 0
    return length > 0 ? 'success' : 'error'
  }

  /**
   * Render Loans Collaterals
   *
   * @returns JSX
   */
  renderLoanCollateral = () => {

    const collateralValues = [],
      collateralNames = [],
      defaultValues = []
    let index = 0

    const { loanCollateralsValidate, loanCollaterals } = this.state

    for(let col in LoanCollateral) {
      collateralValues[index] = LoanCollateral[col]
      collateralNames[index] = col

      if(loanCollaterals.indexOf(col) > -1) {
        defaultValues.push(index)
      }
      index++
    }

    return (
      <FormGroup controlId="loanCollaterals" validationState={ loanCollateralsValidate }>

        <ControlLabel>
          Loans Collaterals <small className="gray">(Choose at least one)</small>
        </ControlLabel>

        <ButtonToolbar>

          <ToggleButtonGroup 
            onChange={ values => {
              const matches = []
              for (let i = 0; i < values.length; i++) {
                matches.push(collateralNames.at(values.at(i)))
              }
              this.setState({
                loanCollaterals: matches,
                loanCollateralsValidate: this.getLoanCollateralsValidateState(matches)
              })
            }}
            type="checkbox"
            defaultValue={ defaultValues }>
            { collateralValues.map((value, index) => (
              <ToggleButton key={ index } value={ index }>{ value }</ToggleButton>
            ))}
          </ToggleButtonGroup>

        </ButtonToolbar>
      </FormGroup>
    )
  }

  /**
   * Render link Loans
   *
   * @returns JSX
   */
  renderLinkLoan() {

    const tab = ['Yes', 'No'],
    { canLinkToExistingDevice } = this.state

    return (
      <FormGroup controlId='mandatory' validationState='success'>
        <ControlLabel>Can creators link a loan to an existing device?</ControlLabel>
        <ButtonToolbar>

          <ToggleButtonGroup
            onChange={value => this.setState({ canLinkToExistingDevice: value === 'Yes' ? true : false })}
            type="radio"
            name="canLinkToExistingDevice"
            defaultValue={ canLinkToExistingDevice ? 'Yes' : 'No' }>
            { tab.map((value, index) => (
              <ToggleButton key={ index } value={ value }>{ value }</ToggleButton>
            ))}
          </ToggleButtonGroup>

        </ButtonToolbar>
      </FormGroup>
    )
  }

  render() {

    const { isNew, active, openedOnValidationState, openedOn, showOpenedOnHelp, name,
      email, deviceApiKey, iconeURL, error, running, success, progressNumber, resubmitId,
      nbDaysManualExtension, manualExtensionState } = this.state,

    dataBreadCrumbs = [{ url: '/organizations', title: 'Organizations' }]

    return (
      <div>

        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />

        <Col smOffset={2} md={7} className="simple-form margin-bottom-40">
          <Form>

            <h3 className="text-center">
              { isNew ? 'New Organization' : 'Update Organization' }
            </h3>
            <hr/>
 
            <FormGroup controlId='active' validationState='success'>
              <ControlLabel>Status</ControlLabel>
              <FormControl
                id="active"
                componentClass="select"
                placeholder="Select"
                value={ active.value }
                onChange={ active.onChange }>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </FormControl>
            </FormGroup>

            <FormGroup controlId="openedOn" validationState={ openedOnValidationState }>

              <ControlLabel>Opened on</ControlLabel>

              <FormControl type="date" placeholder="Opening date"
                value={ openedOn }
                onChange={e => this.openedOnChanged(e.target.value)}
                min='2009-01-01'
                max={ moment().format("YYYY-MM-DD") }
              />

              <span className="gray">
                <FontAwesome name="question" /> &nbsp; 

                { showOpenedOnHelp 
                ? <span>The &#171;Opened on&#187; date must be older than loans start dates. &nbsp;
                  <span className="cursor-pointer" onClick={() => this.setState({ showOpenedOnHelp: false })}>
                    [show less]
                  </span>
                </span>
                : <span className="cursor-pointer" onClick={() => this.setState({ showOpenedOnHelp: true })}>
                  [show help]
                </span>
                }
              </span>
            </FormGroup>

            <FieldGroup
              label="Name"
              id="name"
              type="text"
              placeholder="Enter name"
              value={ name.value }
              onChange={ name.onChange }
              validationState={ name.validation }
              validationMessage="Name must not be empty"
              bsClass="form-control"
            />

            <FieldGroup
              label="Email"
              id="email"
              type="text"
              placeholder="Enter email"
              value={ email.value }
              onChange={ email.onChange }
              validationState={ email.validation }
              validationMessage="Enter a valid email"
              bsClass="form-control"
              disabled={ !isNew }
            />

            <FieldGroup
              label="Device Api Key"
              id="deviceApiKey"
              type="text"
              placeholder="Enter the device Api Key"
              value={ deviceApiKey.value }
              onChange={ deviceApiKey.onChange }
              validationState={ deviceApiKey.validation }
              validationMessage="Enter a valid device Api Key"
              bsClass="form-control"
            />

            <FormGroup controlId="nbDaysManualExtension" validationState={ manualExtensionState }>

              <ControlLabel>Max manual extension (days)</ControlLabel>

              <FormControl type="number" placeholder="Number of days"
                value={ nbDaysManualExtension }
                onChange={e => this.manualExtensionChanged(e.target.value)}
                min="0"
              />
            </FormGroup>

            { this.renderLoanCollateral() }

            { this.renderLinkLoan() }
            <br/>

            <ControlLabel>Organization icon</ControlLabel>
            <br/>
            { !!iconeURL && <Image alt="Organization icon" src={ iconeURL } rounded /> }
            <input
              id="upload-image"
              accept="image/png,image/jpg,image/jpeg"
              type="file"
              onChange={ this.handleImageChange }
            /><br/>
          </Form>

          <ProcessesStatus
            error={ error }
            running={ running }
            success={ success }
            runningText={ `Running.. (${ progressNumber }/2)` }
          />

          {(error && progressNumber > 0) &&
            <Alert bsStyle="danger">
              <p className='reloadSave' onClick={ this.resubmitSubTask }>
                <FontAwesome name="exclamation-circle" size="lg" /> Click here to reload
              </p>
            </Alert>
          }

          <div className="align-right mt-30">
            <Button bsStyle="success" onClick={ this.saveClicked } className="w-120"
              disabled={ !!(running || resubmitId) }>
              <FontAwesome name='save' size="lg"/> Save
            </Button>
          </div>
        </Col>
      </div>
    )
  }
}

export default OrganizationForm



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationForm.js